import { createBrowserRouter } from "react-router-dom";
import RootLayout from "./layout/RootLayout";
import HomePage from "./pages/Home";
import NotFound from "./pages/NotFound";
import ScrollToTop from "./ScrollToTop";
import OutdoorSports from "./pages/products/OutdoorSports";
import PlaygroundPage from "./pages/products/Playground";
import EshopPage from "./pages/e-shop";
import News from "./pages/recents/News";

import GalleryPage from "./pages/services/Gallery";
import SafeCoatingsPage from "./pages/Safecoatings";
import EshopProduct from "./components/eshop/EshopProduct";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <>
        <ScrollToTop />
        <RootLayout />
      </>
    ),
    children: [
      {
        path: "/",
        element: <HomePage />,
      },
      { path: "/zaidimu-aiksteles", element: <PlaygroundPage /> },
      { path: "/lauko-sportas", element: <OutdoorSports /> },
      { path: "/saugios-dangos", element: <SafeCoatingsPage /> },

      {
        path: "/galerija",
        element: <GalleryPage />,
      },

      {
        path: "/el-parduotuve",
        element: <EshopPage />,
      },
      {
        path: "/el-parduotuve/*",
        element: <EshopProduct />,
      },
      { path: "/naujausi", element: <News /> },

      {
        path: "*",
        element: <NotFound />,
      },
    ],
  },
]);

export default router;
